import { SubjectedToVat } from '@/generated/graphql/types';

import type { CompanyWithVat } from './interfaces';

export interface CompanyState {
  data: CompanyWithVat;
  isFetching: boolean | null;
  hasSucceeded?: boolean;
  error: {
    hasError: boolean;
    errorKey: string | null;
  };
}

export const initialProCompany: CompanyWithVat = {
  fiscalNumber: null,
  address: null,
  companyName: null,
  specialties: null,
  receivePhoneCallOffers: null,
  crossBorderVat: {
    vatStatus: null,
    vatNumber: null,
    subjectedToVat: SubjectedToVat.NOT_INFORMED,
    isFraudSuspected: false,
  },
  zipCode: null,
};

export const companyInitialState: CompanyState = {
  data: initialProCompany,
  isFetching: null,
  error: {
    hasError: false,
    errorKey: null,
  },
};
